import { mapGetters } from 'vuex'
import i18n from '@/locales'

export default {
  computed: {
    ...mapGetters(['l3PermissionEnable', 'userInfo', 'isAdminMode']),
  },
  created () {
    this.singleActions = [
      {
        label: i18n.t('bill.rerun_bill'),
        permission: 'cloudaccounts_perform_update_credential',
        action: obj => {
          this.createDialog('BilltasksCreateDialog', {
            type: 'rerun_bill',
            data: [obj],
            account_id: obj.id,
          })
        },
        meta: obj => {
          const ret = { validate: true }
          const ownerDomain = this.isAdminMode || obj.domain_id === this.userInfo.projectDomainId
          if (!ownerDomain) {
            ret.validate = false
            return ret
          }
          if (obj.status === 'deleted') {
            ret.validate = false
            return ret
          }
          if (!obj.tenant_id) {
            ret.validate = false
            ret.tooltip = this.$t('bill.please_set_project_mapping')
          }
          return ret
        },
      },
    ]
  },
}
